import React from 'react';
import { Button, Icon } from '@doxyme/ui';
import { useIntl } from 'react-intl';
import './TroubleshootingWizardHeader.scss';
export const TroubleshootingWizardHeader = ({ title, onClose, titleId }) => {
    const intl = useIntl();
    const closeLabel = intl.formatMessage({ id: 'troubleshooting.wizard.close' });
    return (<div className="troubleshooting-wizard-header">
      <h2 id={titleId} className="troubleshooting-wizard-header__title">
        {title}
      </h2>
      <Button className="troubleshooting-wizard-header__close" onClick={onClose} btnStyle="flat" size="small" color="black" iconOnly aria-label={closeLabel} title={closeLabel}>
        <Icon className="troubleshooting-wizard-header__close-icon" name="call-settings-close" size="xx-small"/>
      </Button>
    </div>);
};
